"use strict";

import React from "react";
import _ from "lodash";
import cx from "classnames";

function TabBar(props) {
  let { baseClassName, className, selectedTab, tabs, onSelect, style } = props;

  return (
    <div className={cx(baseClassName, className)} style={style}>
      {_.map(tabs, function (tab) {
        return (
          <div
            key={tab.id}
            className={cx(baseClassName + "__tab", selectedTab == tab.id ? "is-active" : "")}
            onClick={() => onSelect(tab.id)}
          >
            {tab.label}
          </div>
        );
      })}
    </div>
  );
}

TabBar.defaultProps = {
  baseClassName: "si-c-tabbar",
};

export default TabBar;
